export default {
  links: [
    { title: 'Terms', url: '/terms-and-conditions' },
    { title: 'Privacy', url: '/privacy-policy' },
    { title: 'Conduct', url: '/supplier-code-of-conduct' },
  ],
  copyright: `©${new Date().getFullYear()} DIAMOND FOUNDRY INC.`,
};
